import {useEffect, useState} from "react";
import {Link, useLocation, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

const MenuItem = ({item}) => {
  const {iconStyle, title, titleKey, to, condition, titleSecond, activeIcon} = item;
  const {t} = useTranslation();
  const {pathname} = useLocation();
  const [active, setActive] = useState(false);

  useEffect(() => {
    const activeMenu = pathname.split("/")[1];

    if (activeMenu === to) {
      setActive(true);
    } else if (activeMenu === "annonce" && to === "") {
      setActive(true);
    }
  }, [pathname]);

  return (
    <Link
      to={to}
      className={`flex flex-col gap-[6px] lg:px-3 2xl:px-[20px] text-[#3D4465] hover:text-[#0F47B3] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0F47B3] h-full justify-center items-center lg:text-lg 2xl:text-xl py-[10px] flex-shrink ${
        !!condition ? "text-[#FF6600]  !gap-[2px]  min-[1745px]:px-[20px]" : ""
      } ${
        active &&
        (!!condition
          ? "!text-[#0F47B3] border-b-2 border-solid border-[#0F47B3]"
          : "text-[#0F47B3] border-b-2 border-solid border-[#0F47B3]")
      }`}
    >
      {active ? activeIcon : iconStyle}
      <span
        className={`text-[14px] font-semibold text-center w-auto leading-4 flex ${
          !!condition
            ? "text-nowrap max-w-[110px]  mt-[3px] "
            : "2xl:text-nowrap"
        }`}
      >
        {t(titleKey ?? title)}
      </span>
      {!!condition && !titleKey && (
        <span className="text-[14px] font-semibold text-center w-auto leading-4 flex">
          {titleSecond}
        </span>
      )}
    </Link>
  );
};
export default MenuItem;
